function _of(x) {
  return [x];
}
module.exports = _of;


//////////////////
// WEBPACK FOOTER
// ../~/ramda/src/internal/_of.js
// module id = 842
// module chunks = 0